import type { AbstractAuthenticationToken, AuthenticationConverter } from './types.ts';
import type { X509PrincipalExtractor } from './preauth/x509.ts';
import type { ServerWebExchange } from '../../../types/web/server';

export const x509Converter = (opts: { principalExtractor: X509PrincipalExtractor }): AuthenticationConverter => {
    const { principalExtractor } = opts;
    return async (exchange: ServerWebExchange): Promise<AbstractAuthenticationToken | undefined> => {
        const sslInfo = exchange.request.sslInfo;
        if (sslInfo === undefined) {
            // no SslInfo provided with a request, skipping x509 authentication
            return;
        }
        if (sslInfo.peerCertificate === undefined) {
            // no peer certificate found in SslInfo, skipping x509 authentication
            return;
        }
        const clientCertificate = sslInfo.peerCertificate;
        const principal = principalExtractor(clientCertificate);
        return {
            type: 'PreAuthenticated',
            authenticated: false,
            principal,
            name: principal ?? '',
            credentials: clientCertificate
        };
    }
}
